import { getStoredRefreshToken, nodeApi, storeAccessToken, storeRefreshToken } from "api/Middleware";

/**
 * Best-effort server logout + always clear local JWT storage.
 * Local teardown must succeed even when the API returns 401.
 */
export async function logoutSession() {
	const jwtAuth =
		process.env.REACT_APP_JWT_AUTHENTICATION === "true" ||
		process.env.REACT_APP_JWT_AUTHENTICATION === "1";

	if (jwtAuth) {
		try {
			const refreshToken = getStoredRefreshToken();
			await nodeApi.post(
				"/auth/logout",
				refreshToken ? { refreshToken } : {},
				{
					skipAuthorization: true,
					skipAuthRefresh: true,
					timeout: 5000,
				}
			);
		} catch {
			// Ignore API failures (including 401) — callers still clear Redux/local tokens.
		}
	}

	try {
		storeAccessToken("");
		storeRefreshToken("");
	} catch {
		// Best-effort local fallback.
	}
}
